const clearStorage = () => {
    sessionStorage.removeItem('uid')
    sessionStorage.removeItem('vid')
    sessionStorage.removeItem('pid')
    sessionStorage.removeItem('tid')
    sessionStorage.removeItem('sid')
}

export default clearStorage;